const box3 = document.querySelector(".box3");
const box4 = document.querySelector(".box4");
const box5 = document.querySelector(".box5");
const box6 = document.querySelector(".box6");
const box7 = document.querySelector(".box7");
const box8 = document.querySelector(".box8");
const box8M = document.querySelector(".box8-m");




const skip3 =  document.querySelector(".param1_item2");
const skip4 =  document.querySelector(".param1_item3");
const skip5 =  document.querySelector(".param1_item1_2");
const skip6 =  document.querySelector(".param2_skip1");
const skip7 =  document.querySelector(".param2_skip2");
const skip8 =  document.querySelector(".param2_skip3");

const skip9 =  document.querySelector(".param3_item1");
const skip10 =  document.querySelector(".param2_skip1-m");
const skip11 =  document.querySelector(".param2_skip2-m");
const skip12 =  document.querySelector(".param2_skip3-m");


// const box2Info = document.querySelector(".box2-info");
// const infoHeader = document.querySelector(".info-header");
const box2Text = 'Our new Mobile ePaper device combines cutting-edge performance with an E Ink display and a phone-sized design, allowing you to effortlessly slip it into your pocket and carry it on the go. '
const infoText = document.querySelector(".info-text");
const box8Content = document.querySelector(".box8-content");
const box8Scroll = document.querySelector(".box8-scroll");
const box8List = document.querySelectorAll(".box8-list li");
const box8ListImg = document.querySelectorAll(".box8-list_img>div");

let video3 = document.querySelector("#video3");
let video3Replay = document.querySelector(".video3-replay");


const regex = /(\S+)\s/g;
const matches = [];
let match;

while ((match = regex.exec(box2Text)) !== null) {
  matches.push(match[1]);
}

matches.forEach((match,index) => {

  const matchDiv = document.createElement('span');
  matchDiv.textContent = match + '\u00A0';
  matchDiv.classList.add('info_item'); // 添加类名 "info_item"
  if(
    index == 6 ||
    index == 7 ||
    index == 15 ||
    index == 29 ||
    index == 30 ||
    index == 31 
  ){
    matchDiv.style.fontWeight = '600'
  }
  infoText.appendChild(matchDiv);
});

// 页面滚动 文本逐字变颜色
ScrollTrigger.create({
  trigger: '.box2-info',
  start: 'top 60%',
  end:'center 60%' ,
  scrub: true,
  onUpdate(self){
    const infoHeader = document.querySelector(".info-header");
    const infoItem = document.querySelectorAll(".info_item");
    let frame = Math.ceil(self.progress * infoItem.length)
    if (frame > 0) {
      infoHeader.classList.add('see_text');
    } else if (frame == 0) {
      infoHeader.classList.remove('see_text');
    }

    infoItem.forEach((item, index) => {
      if (frame < infoItem.length && frame >= 0) {
        item.classList.remove('see_text');
      }
      if (index < frame) {
        item.classList.add('see_text');
      }
    });
  }
})

// 点击滚到到元素位置
function distanceToTop(clickEl,GoEl){
  clickEl.addEventListener('click',()=>{

    const distanceToTop  = GoEl - 150

    window.scrollTo({top:distanceToTop})
    // window.scrollTo({top:distanceToTop,behavior: "smooth"})
  })
}
distanceToTop(skip3,box3.offsetTop);
distanceToTop(skip4,box4.offsetTop);
distanceToTop(skip5,box5.offsetTop);
distanceToTop(skip6,box6.offsetTop);
distanceToTop(skip7,box7.offsetTop);
distanceToTop(skip8,box8.offsetTop);
distanceToTop(skip9,box4.offsetTop);
distanceToTop(skip10,box6.offsetTop);
distanceToTop(skip11,box7.offsetTop);
distanceToTop(skip12,box8M.offsetTop);

// 元素到可视区域添加class
function fadeInOnScroll(element, className, noRemove = false) {
  const isInViewport = function(element) {
    const rect = element.getBoundingClientRect();
    let windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return (
      rect.top >= -100 && rect.top <= (windowHeight-(windowHeight*0.1))
      // rect.left >= 0 &&
      // rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      // rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };


  const handleScroll = function() {

    if(noRemove){
      if (isInViewport(element)) {
        element.classList.add(className);
      }
    }else{
      if (isInViewport(element)) {
        element.classList.add(className);
      }else {
        element.classList.remove(className);
      }
    }
    
  };

  window.addEventListener('scroll', handleScroll);
}

// fadeInOnScroll(document.querySelector('.box1-info'), 'fade-in-bottom');

fadeInOnScroll(document.querySelector('.box7-info_img-box'), 'fade-in', true);



// 滚动切换图片与内容

box8List.forEach((item,index) =>{
  item.addEventListener('click',(e)=>{
    box8List.forEach((item) => item.classList.remove('active'));
    box8ListImg.forEach((item) => item.classList.remove('active'));
    box8ListImg[index].classList.add('active');
    item.classList.add('active');
  })
})


gsap.registerPlugin(ScrollTrigger);

let sections = gsap.utils.toArray(".box8-m-c-list>.list_itme");

let scrollTween = gsap.to(sections, {
    xPercent: -100 * (sections.length - 1),
    ease: "none", // <-- IMPORTANT!
    scrollTrigger: {
      trigger: ".box8-m",
      pin: true,
      scrub: 0.1,
      //snap: directionalSnap(1 / (sections.length - 1)),
      end: "+=1000"
    }
  });

// ScrollTrigger.create({
//   trigger: '.box8-m',
//   start: 'top 5%',
//   end:'bottom 5%' ,
//   scrub: true,
//   pin: true,
//   onUpdate(self){
//     const box8MList = document.querySelectorAll(".box8-m-content .list_itme");
//     box8MList.forEach((item) => item.classList.remove('active'));
//     let frame = self.progress
//     if (frame >= 0 && frame < 0.4) {
//       box8MList[0].classList.add('active');
//     } else if (frame >= 0.4 && frame < 0.8) {
//       box8MList[1].classList.add('active');
//     } else if (frame >= 0.8) {
//       box8MList[2].classList.add('active');
//     }
//   }
// })

// 视频

video3Replay.addEventListener('click', ()=>{
  video3Replay.style.display = 'none'
  video3.play()
})

video3.addEventListener('ended', ()=>{
  video3Replay.style.display = 'flex'
})

ScrollTrigger.create({
  trigger: '#video3',
  start: 'top bottom',
  end:'top bottom',
  onUpdate(self){
    let frame = self.progress
    if (frame == 1) {
      video3Replay.style.display = 'none'
      video3.play()
    }
  }
})

// new Splide( '#box10-splide', {
//   type   : 'loop',
//   drag   : 'free',
//   focus  : 'center',
//   arrows: false, // 取消箭头
//   // pagination: false, // 取消下标
//   perPage: 1.5,
//   autoScroll: false,
//   breakpoints: {
//     992: {
//         perPage: 1
//     },
//   },
// } ).mount();

new Splide( '#box10-splide', {
  type   : 'loop',
  padding: '20%',
  arrows: false, // 取消箭头
  breakpoints: {
    600: {
        padding: '0%',
    },
  },
} ).mount();


